import _each from "lodash/each";
import { gsap } from "gsap";
import store from "~/js/store/store";
export default class SideNavi {
  constructor() {
    this.view = document.querySelector("#navi-wrap");
    this.playPauseButton = document.querySelector(".js-play-pause-button");
    this.setup();
  }

  setup() {
    const naviList = document.querySelectorAll(".js-sectionnavi");
    this.unsubscribe = store.subscribe((mutation, state) => {
      if (mutation.type === "pinSectionAutoplayTime") {
        this.updateCircleIndicator(state.app.pinSection.autoPlayTime);
      }
    });
    _each(naviList, (elm, index) => {
      elm.addEventListener("click", (event) => {
        event.preventDefault();
        let target = event.currentTarget;
        let _active = target.getAttribute("data-active");
        store.dispatch("changePinScroll", {
          index: parseInt(_active, 10)
        });
        // this.goToSection(parseInt(_active, 10))
      });

      // const iconColor = getComputedStyle(elm).getPropertyValue('--icon-color-pc').trim();
      // const borderColor = this.getContrastColor(iconColor);
      // elm.style.setProperty('--border-color-pc', borderColor);
    });
  }

  // サイドナビ更新
  updateNavi() {
    let currentIndex = store.state.app.pinSection.nextIndex;
    const naviList = this.view.querySelectorAll(".js-sectionnavi");
    const sections = document.querySelectorAll(".js-section");
    _each(naviList, (elm, index) => {
      let circle = elm.querySelector(".js-circle");
      if (circle) {
        gsap.set(circle, {
          "stroke-dashoffset": 50
        });
      }
      elm.classList.remove("active");
      elm.setAttribute('aria-current', false)
      if (index === currentIndex) {
        elm.classList.add("active");
        elm.setAttribute('aria-current', true)
        let section = sections[index];
        this.view.classList.remove("white");
        this.view.setAttribute('data-current-index', index)
        this.playPauseButton?.classList.remove("white");
        if (section.classList.contains("white_pc")) {
          if (window.innerWidth >= 1025) {
            this.view.classList.add("white");
            this.playPauseButton?.classList.add("white");
          }
        } else if (section.classList.contains("white_sp")) {
          if (window.innerWidth <= 1024) {
            this.view.classList.add("white");
            this.playPauseButton?.classList.add("white");
          }
        } else if (section.classList.contains("white")) {
          this.view.classList.add("white");
          this.playPauseButton?.classList.add("white");
        }

        // const iconColor = getComputedStyle(elm).getPropertyValue('--icon-color-pc').trim();
        // const borderColor = this.getContrastColor(iconColor);
        // elm.style.setProperty('--border-color-pc', borderColor);
      }
    });
  }

  // 自動再生インジケーターの更新
  updateCircleIndicator(time) {
    const currentIndex = store.state.app.pinSection.nextIndex;
    const naviList = this.view.querySelectorAll(".js-sectionnavi");
    let targetCircle = naviList[currentIndex];
    if (targetCircle) {
      targetCircle = targetCircle.querySelector(".js-circle");
      if (targetCircle) {
        gsap.set(targetCircle, {
          "stroke-dashoffset": 50 - time * 25
        });
      }
    }
  }

  getRelativeLuminance(r, g, b) {
    r = r / 255;
    g = g / 255;
    b = b / 255;

    r = r <= 0.03928 ? r / 12.92 : Math.pow((r + 0.055) / 1.055, 2.4);
    g = g <= 0.03928 ? g / 12.92 : Math.pow((g + 0.055) / 1.055, 2.4);
    b = b <= 0.03928 ? b / 12.92 : Math.pow((b + 0.055) / 1.055, 2.4);

    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
  }

  getContrastRatio(lum1, lum2) {
    const lighter = Math.max(lum1, lum2);
    const darker = Math.min(lum1, lum2);
    return (lighter + 0.05) / (darker + 0.05);
  }

  getContrastColor(bgColor) {
    let r, g, b;

    if (bgColor.startsWith('rgba') || bgColor.startsWith('rgb')) {
      const match = bgColor.match(/\d+(\.\d+)?/g);
      if (match) {
        r = parseInt(match[0]);
        g = parseInt(match[1]);
        b = parseInt(match[2]);
      } else {
        return '#fff';
      }
    } else {
      return '#fff';
    }

    const bgLuminance = this.getRelativeLuminance(r, g, b);
    
    const whiteContrast = this.getContrastRatio(bgLuminance, 1);
    const blackContrast = this.getContrastRatio(bgLuminance, 0);

    return whiteContrast > blackContrast ? '#fff' : '#000';
  }
}
